import { useEffect, useState } from "react";

const usePWADetection = () => {
  const [isPWA, setIsPWA] = useState(false);
  useEffect(() => {
    const query = window?.matchMedia("(display-mode: standalone)");
    setIsPWA(query.matches);
    const handleChange = (event: MediaQueryListEvent) => {
      setIsPWA(event.matches);
    };
    query.addEventListener("change", handleChange);
    return () => {
      query.removeEventListener("change", handleChange);
    }
  }, []);
  return { isPWA };
};

export default usePWADetection;
